import { NumberInput, SelectDropdown } from '@makyoapp/makyo-ui'

import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'

interface INumberWithUnitSettings {
  step?: number | undefined
  min?: number | undefined
  options: {
    value: string
    label: string
    max?: number | undefined
  }[]
}

const NumberWithUnitFieldSetting = ({
  id,
  settingId,
  value,
  numberWithUnitSettings,
}: {
  id: string
  settingId: string
  value: any
  numberWithUnitSettings?: INumberWithUnitSettings
}) => {
  const updateValue = useUpdateCompSettingValue(id)
  const { min = 0, step = 1, options = [] } = numberWithUnitSettings ?? {}
  const v = value as { value: number; unit: string } | undefined
  return (
    <div className='flex-c'>
      <NumberInput
        id={settingId}
        min={min}
        max={
          v?.unit
            ? (options.find((opt) => opt?.value === v?.unit)?.max ?? options[0]?.max ?? 10)
            : (options[0]?.max ?? 10)
        }
        step={step}
        value={v?.value}
        onChange={async (n) => {
          await updateValue({
            ...(v ?? {}),
            value: n,
          })
        }}
      />
      <SelectDropdown
        onChange={async (opt) => {
          const currValue = v?.value
          const newMax = options.find((o) => o?.value === opt.value)?.max ?? options[0]?.max ?? 10

          // if currValue is greater than newMax, set currValue to 1
          await updateValue({
            value: currValue && currValue > newMax ? 1 : currValue,
            unit: opt.value,
          })
        }}
        value={options.find((opt) => opt?.value === v?.unit)}
        optionLabel={(opt) => `${opt.value} ${opt.label}`}
        renderOption={(opt: { value: string; label: string }) => opt?.label}
        options={options}
      />
    </div>
  )
}

export default NumberWithUnitFieldSetting
